(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function initMobileNav() {
    const nav = qs('[data-mobile-nav]');
    const openBtn = qs('[data-mobile-nav-open]');
    const closeBtn = qs('[data-mobile-nav-close]');
    const overlay = qs('[data-mobile-nav-overlay]');
    if (!nav || !openBtn) return;

    function open() {
      nav.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    qsa('[data-mobile-nav] a').forEach(function (link) {
      link.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  function initCartDrawer() {
    if (document.documentElement.dataset.cartDrawerBound === 'true') return;
    document.documentElement.dataset.cartDrawerBound = 'true';

    function open() {
      const drawer = qs('[data-cart-drawer]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      const drawer = qs('[data-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        open();
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        close();
      }
      if (e.target.closest('[data-cart-overlay]')) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      const drawer = qs('[data-cart-drawer]');
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });
    document.addEventListener('cart:open', open);
    window.__nyxInitCartDrawer = initCartDrawer;
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function initProductForm() {
    const form = qs('[data-product-form]');
    if (!form) return;
    const sectionId = form.getAttribute('data-product-form');
    const jsonEl = qs('#ProductJson-' + sectionId);
    if (!jsonEl) return;
    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    const idInput = qs('input[name="id"]', form);
    const priceEl = qs('#ProductPrice');
    const submitBtn = qs('.product-form__submit', form);

    function findVariant() {
      const selects = qsa('select[name^="options"]', form);
      if (!selects.length) return product.variants[0];
      const options = selects.map(function (s) {
        return s.value;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function onChange() {
      const variant = findVariant();
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      const gallery = qs('[data-product-gallery]');
      const mainImage = qs('[data-gallery-main]', gallery || document);
      const variantSrc =
        (variant.featured_image && variant.featured_image.src) ||
        (variant.featured_media &&
          variant.featured_media.preview_image &&
          variant.featured_media.preview_image.src);
      if (mainImage && variantSrc) {
        const resolvedSrc = variantSrc.indexOf('//') === 0 ? 'https:' + variantSrc : variantSrc;
        const separator = resolvedSrc.indexOf('?') >= 0 ? '&' : '?';
        const imageSrc = resolvedSrc + separator + 'width=900';
        mainImage.setAttribute('src', imageSrc);
        mainImage.src = imageSrc;
        qsa('[data-gallery-thumb]', gallery || document).forEach(function (thumb) {
          const thumbSrc = thumb.getAttribute('data-full-src') || '';
          thumb.classList.toggle(
            'is-active',
            thumbSrc.split('?')[0] === variantSrc.split('?')[0]
          );
        });
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? submitBtn.getAttribute('data-add-text') || submitBtn.textContent
          : submitBtn.getAttribute('data-sold-text') || 'Sold out';
      }
    }

    const selects = qsa('select[name^="options"]', form);
    selects.forEach(function (select) {
      select.addEventListener('change', onChange);
    });
    onChange();
  }

  function initQuantityControls() {
    if (document.documentElement.dataset.quantityControlsReady === 'true') return;
    document.documentElement.dataset.quantityControlsReady = 'true';

    function updateLine(control, quantity) {
      const line = control.getAttribute('data-line');
      const key = control.getAttribute('data-line-key');
      if (!line && !key) return;
      const input = qs('[data-quantity-input]', control);
      const previous = input ? input.value : '';
      const nextQuantity = Math.max(0, parseInt(quantity, 10) || 0);
      if (input) input.value = nextQuantity;
      qsa('button, input', control).forEach(function (el) { el.disabled = true; });
      const payload = { quantity: nextQuantity };
      if (line) payload.line = parseInt(line, 10);
      else payload.id = key;
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          if (input) input.value = previous;
          qsa('button, input', control).forEach(function (el) { el.disabled = false; });
        });
    }

    document.addEventListener('click', function (event) {
      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        const line = removeBtn.getAttribute('data-line');
        if (!line) return;
        removeBtn.disabled = true;
        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('remove failed'); return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { removeBtn.disabled = false; });
        return;
      }
    });

    document.addEventListener('click', function (event) {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        const gallery = thumb.closest('[data-product-gallery]');
        const main = gallery && gallery.querySelector('[data-gallery-main]');
        const src = thumb.getAttribute('data-full-src');
        if (main && src) {
          main.src = src;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
        return;
      }
    });

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-quantity-minus], [data-quantity-plus], [data-product-quantity-minus], [data-product-quantity-plus]');
      if (!button) return;
      const control = button.closest('[data-qty-control], [data-product-qty-control]');
      if (!control) return;
      const input = qs('[data-quantity-input]', control);
      if (!input) return;
      event.preventDefault();
      const current = Math.max(0, parseInt(input.value, 10) || 0);
      const next = button.matches('[data-quantity-minus], [data-product-quantity-minus]') ? current - 1 : current + 1;
      if (control.hasAttribute('data-line') || control.hasAttribute('data-line-key')) updateLine(control, next);
      else input.value = Math.max(1, next);
    });

    document.addEventListener('change', function (event) {
      const input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      const control = input.closest('[data-qty-control]');
      if (control) updateLine(control, input.value);
      else input.value = Math.max(1, parseInt(input.value, 10) || 1);
    });
  }

  function initPromoCode() {
    qsa('[data-promo-form]').forEach(function (form) {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const input = qs('input[name="code"]', form);
        const code = input ? input.value.trim() : '';
        if (code) window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
      });
    });
    qsa('[data-copy-promo]').forEach(function (button) {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', function () {
        const code = button.getAttribute('data-copy-promo') || '';
        const status = button.closest('.promo-block') && qs('[data-copy-status]', button.closest('.promo-block'));
        const done = function () { if (status) status.textContent = 'Copied'; };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(function () {});
        else {
          const temp = document.createElement('textarea');
          temp.value = code;
          document.body.appendChild(temp);
          temp.select();
          document.execCommand('copy');
          temp.remove();
          done();
        }
      });
    });
  }

  function initProductRecommendations() {
    const el = qs('product-recommendations');
    if (!el) return;
    const url = el.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('product-recommendations');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCartDrawer();
    updateCartCount();
    initProductForm();
    initQuantityControls();
    initPromoCode();
    initProductRecommendations();

    document.addEventListener('cart:refresh', updateCartCount);
  });

  document.addEventListener('shopify:section:load', function () {
    initMobileNav();
    initCartDrawer();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      form.setAttribute('data-intent', 'buy-now');
      var ret = form.querySelector('[data-return-to]');
      if (ret) ret.value = '/checkout';
    });
  });
  document.querySelectorAll('.product-form__submit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      form.setAttribute('data-intent', 'add');
      var ret = form.querySelector('[data-return-to]');
      if (ret) ret.value = '';
    });
  });
  document.querySelectorAll('form[data-product-form], form.product-form').forEach(function (form) {
    if (form.dataset.ajaxCartReady === 'true') return;
    form.dataset.ajaxCartReady = 'true';
    form.addEventListener('submit', function (event) {
      var intent = form.getAttribute('data-intent') || 'add';
      if (intent === 'buy-now') return; // normal submit → checkout via return_to
      event.preventDefault();
      var submitBtn = form.querySelector('.product-form__submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('data-prev-label', submitBtn.textContent);
        submitBtn.textContent = 'Adding…';
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var fd = new FormData(form);
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return fetch(root + '?sections=cart-drawer');
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Drawer refresh failed');
          return response.json();
        })
        .then(function (sections) {
          var html = sections && sections['cart-drawer'];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-cart-drawer]');
            var current = document.querySelector('[data-cart-drawer]');
            if (next && current) current.replaceWith(next);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          // re-bind drawer controls on replaced node
          if (typeof window.__nyxInitCartDrawer === 'function') window.__nyxInitCartDrawer();
        })
        .catch(function () {
          // fallback: stay on product (no /cart redirect)
          window.location.assign(window.location.pathname + window.location.search);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-prev-label') || submitBtn.getAttribute('data-add-text') || 'Add to cart';
          }
          form.removeAttribute('data-intent');
        });
    });
  });
});
